import { useState } from "react";
export function ExpandableText({ text, maxLength = 120, clampClass = "line-clamp-3", textClass = "text-white" }) {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className={"text-md font-light  whitespace-pre-line "+textClass} style={{ lineHeight: '1.6' }}>
      <p className={expanded ? "" : clampClass}>{text}</p>
      {text.length > maxLength && ( // only show button if text is long
        <button
          onClick={() => setExpanded(!expanded)}
          className="mt-2 text-sm font-semibold underline"
        >
          {expanded ? "Rādīt mazāk" : "Rādīt vairāk"}
        </button>
      )}
    </div>
  );
}